import { useEffect, memo, Fragment, useState } from "react";
import { Row, Col, Dropdown, Button, Spinner } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Circularprogressbar from "../../components/circularprogressbar.js";
import AOS from "aos";
import "../../../node_modules/aos/dist/aos";
import "../../../node_modules/aos/dist/aos.css";
import Chart from "react-apexcharts";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation } from "swiper";
import "swiper/swiper-bundle.min.css";
import CountUp from "react-countup";
import { useSelector } from "react-redux";
import * as SettingSelector from "../../store/setting/selectors";
import "./styles.css";
//api controller
import { getDashOverview } from "../../services/service.js";
import { Pagination } from "react-bootstrap";
SwiperCore.use([Navigation]);

// SAFE BILINGUAL TEXT EXTRACTOR
const getBilingualText = (obj, field) => {
  if (!obj || typeof obj !== "object") return "N/A";
  const value = obj[field];
  if (!value || typeof value !== "object")
    return (value || "").toString().trim() || "N/A";
  const en = value.en?.trim() || "";
  const hi = value.hi?.trim() || "";
  if (!en && !hi) return "N/A";
  if (en && hi) return `${en} (${hi})`;
  return en || hi;
};

const Index = memo((props) => {
  const userData = JSON.parse(localStorage.getItem("user"));
  const userName = userData?.user?.name || "Guest";
  const navigate = useNavigate()
  useSelector(SettingSelector.theme_color);
  const getVariableColor = () => {
    let prefix =
      getComputedStyle(document.body).getPropertyValue("--prefix") || "bs-";
    if (prefix) {
      prefix = prefix.trim();
    }
    const color1 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}primary`
    );
    const color2 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}info`
    );
    const color3 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}primary-tint-20`
    );
    const color4 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}warning`
    );
    return {
      primary: color1.trim(),
      info: color2.trim(),
      warning: color4.trim(),
      primary_light: color3.trim(),
    };
  };
  const variableColors = getVariableColor();

  const colors = [variableColors.primary, variableColors.info];
  useEffect(() => {
    return () => colors;
  });

  useEffect(() => {
    AOS.init({
      startEvent: "DOMContentLoaded",
      disable: function () {
        var maxWidth = 996;
        return window.innerWidth < maxWidth;
      },
      throttleDelay: 10,
      once: true,
      duration: 700,
      offset: 10,
    });
  });

  // Format date like "01/01/2025"
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB"); // DD/MM/YYYY
  };

  // Inside your component
  const [currentPage, setCurrentPage] = useState(1);
  const jobsPerPage = 8; // adjust as needed
  const [dashboardData, setDashboardData] = useState(null);
  const [equipmentFilter, setEquipmentFilter] = useState("week");
  const [analyticsFilter, setAnalyticsFilter] = useState("weekly");
  // recent jobs + pagination states
  const [recentJobs, setRecentJobs] = useState([]);
  const [currentJobs, setCurrentJobs] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [chart1, setChart1] = useState({ options: {}, series: [] });
  const [chart2, setChart2] = useState({
    options: {},
    series: [],
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getDashOverview();
        if (response?.success) {
          const data = { ...response.data };
          const jobs = data?.jobs?.recent || [];
          setRecentJobs(jobs);
          setTotalPages(Math.ceil(jobs.length / jobsPerPage));
          setCurrentJobs(jobs.slice(0, jobsPerPage));

          // ---------- Jobs Analytics (chart1) ----------
          const chartData = data?.chartData || {};
          const currentAnalytics = chartData[analyticsFilter] || [];

          const categories = currentAnalytics.map((item) =>
            analyticsFilter === "weekly" ? item.date : item.month
          );
          const series = [
            {
              name: "Pending",
              data: currentAnalytics.map((item) => item.Pending || 0),
            },
            {
              name: "In-progress",
              data: currentAnalytics.map((item) => item["In-progress"] || 0),
            },
            {
              name: "Live",
              data: currentAnalytics.map((item) => item.live || 0),
            },
            {
              name: "Complete",
              data: currentAnalytics.map((item) => item.Complete || 0),
            },
            {
              name: "Paused",
              data: currentAnalytics.map((item) => item.paused || 0),
            },
            {
              name: "Extended",
              data: currentAnalytics.map((item) => item.extended || 0),
            },
            {
              name: "Cancelled",
              data: currentAnalytics.map((item) => item.Cancelled || 0),
            },
          ];

          setChart1({
            series: series,
            options: {
              xaxis: { categories: categories },
              colors: [
                "#ffc107",
                "#17a2b8",
                "#007bff",
                "#28a745",
                "#6c757d",
                "#6610f2",
                "#dc3545",
              ],
              tooltip: {
                shared: true,
                intersect: false,
                y: {
                  formatter: (val, { seriesIndex }) => {
                    const statusNames = [
                      "Pending",
                      "In-progress",
                      "Live",
                      "Complete",
                      "Paused",
                      "Extended",
                      "Cancelled",
                    ];
                    return `${val} ${statusNames[seriesIndex]} jobs`;
                  },
                },
              },
            },
          });

          // ---------- Equipment Distribution (chart2) ----------
          const usageStats = data?.equipmentUsageStats || [];
          const equipmentLabels = usageStats.map((item) => item.category);
          const equipmentCounts = usageStats.map((item) => item.count);
          const totalUsage = equipmentCounts.reduce((a, b) => a + b, 0);
          const equipmentSeries = equipmentCounts.map((count) =>
            totalUsage ? Math.round((count / totalUsage) * 100) : 0
          );

          setChart2({
            options: {
              chart: { type: "donut" },
              colors: [
                "#3a57e8",
                "#4bc7d2",
                "#ffc107",
                "#28a745",
                "#ff5733",
                "#9b59b6",
                "#1abc9c",
              ],
              labels: equipmentLabels,
              legend: { position: "bottom" },
              dataLabels: { formatter: (val) => `${Math.round(val)}%` },
            },
            series: equipmentSeries,
          });

          setDashboardData({
            ...data,
            equipmentDistribution: equipmentLabels.map((label, i) => ({
              name: label,
              percent: equipmentSeries[i],
            })),
          });
        }
      } catch (error) {
        console.error("Error fetching dashboard overview:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [analyticsFilter]);

  // update jobs on page change
  useEffect(() => {
    const indexOfLastJob = currentPage * jobsPerPage;
    const indexOfFirstJob = indexOfLastJob - jobsPerPage;
    setCurrentJobs(recentJobs.slice(indexOfFirstJob, indexOfLastJob));
  }, [currentPage, recentJobs]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center p-5">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return (
    <Fragment>
      <Row>
        <Col md="12" lg="12">
          <Row className="row-cols-1">
            <div
              className="overflow-hidden d-slider1"
              data-aos="fade-up"
              data-aos-delay="800"
            >
              <Swiper
                className="p-0 m-0 mb-2 list-inline "
                slidesPerView={5}
                spaceBetween={32}
                navigation={{
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                }}
                breakpoints={{
                  320: { slidesPerView: 1 },
                  550: { slidesPerView: 2 },
                  991: { slidesPerView: 3 },
                  1400: { slidesPerView: 3 },
                  1500: { slidesPerView: 4 },
                  1920: { slidesPerView: 4 },
                  2040: { slidesPerView: 7 },
                  2440: { slidesPerView: 8 },
                }}
              >
                {/* Active Jobs Card */}
                <SwiperSlide className="card card-slide ">
                  <div className="card-body">
                    <div className="progress-widget cursor-pointer" onClick={() => navigate("/jobs")}>
                      <Circularprogressbar
                        stroke={variableColors.primary}
                        width="60px"
                        height="60px"
                        Linecap="rounded"
                        trailstroke="#ddd"
                        strokewidth="4px"
                        style={{ width: 60, height: 60 }}
                        value={75}
                        id="circle-progress-01"
                      >
                        <svg
                          className=""
                          width="24"
                          height="24px"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z"
                          />
                        </svg>
                      </Circularprogressbar>
                      <div className="progress-detail">
                        <p className="mb-2">Active Jobs</p>
                        <h4 className="counter">
                          <CountUp
                            start={0}
                            end={dashboardData?.jobs?.active || 0}
                            duration={3}
                          />
                        </h4>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>

                {/* Total Customers */}
                <SwiperSlide className="card card-slide">
                  <div className="card-body">
                    <div className="progress-widget cursor-pointer" onClick={() => navigate("/dashboard/app/customer-listing")}>
                      <Circularprogressbar
                        stroke={variableColors.primary}
                        width="60px"
                        height="60px"
                        Linecap="rounded"
                        trailstroke="#ddd"
                        strokewidth="4px"
                        style={{ width: 60, height: 60 }}
                        value={75}
                        id="circle-progress-01"
                      >
                        <svg
                          className=""
                          width="24"
                          height="24px"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z"
                          />
                        </svg>
                      </Circularprogressbar>
                      <div className="progress-detail">
                        <p className="mb-2">Total Customers</p>
                        <h4 className="counter">
                          <CountUp
                            start={0}
                            end={dashboardData?.users?.customer || 0}
                            duration={3}
                          />
                        </h4>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                {/* Today's Earnings */}
                <SwiperSlide className="card card-slide">
                  <div className="card-body">
                    <div className="progress-widget">
                      <Circularprogressbar
                        stroke={variableColors.info}
                        width="60px"
                        height="60px"
                        trailstroke="#ddd"
                        strokewidth="4px"
                        Linecap="rounded"
                        style={{ width: 60, height: 60 }}
                        value={65}
                        id="circle-progress-02"
                      >
                        <svg
                          className=""
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z"
                          />
                        </svg>
                      </Circularprogressbar>
                      <div className="progress-detail">
                        <p className="mb-2">Today's Earnings</p>
                        <h4 className="counter">
                          ₹
                          <CountUp
                            start={0}
                            end={
                              dashboardData?.earnings?.today?.netEarnings || 0
                            }
                            duration={3}
                          />
                        </h4>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                {/*Total's Earnings */}
                <SwiperSlide className="card card-slide">
                  <div className="card-body">
                    <div className="progress-widget">
                      <Circularprogressbar
                        stroke={variableColors.info}
                        width="60px"
                        height="60px"
                        trailstroke="#ddd"
                        strokewidth="4px"
                        Linecap="rounded"
                        style={{ width: 60, height: 60 }}
                        value={65}
                        id="circle-progress-02"
                      >
                        <svg
                          className=""
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z"
                          />
                        </svg>
                      </Circularprogressbar>
                      <div className="progress-detail">
                        <p className="mb-2">Total's Earnings</p>
                        <h4 className="counter">
                          ₹
                          <CountUp
                            start={0}
                            end={
                              dashboardData?.earnings?.total?.netEarnings || 0
                            }
                            duration={3}
                          />
                        </h4>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>

                {/* Total Vendors */}
                <SwiperSlide className="card card-slide">
                  <div className="card-body">
                    <div className="progress-widget cursor-pointer" onClick={() => navigate("/dashboard/app/vendor-listing")}>
                      <Circularprogressbar
                        stroke={variableColors.primary}
                        width="60px"
                        height="60px"
                        trailstroke="#ddd"
                        strokewidth="4px"
                        Linecap="rounded"
                        style={{ width: 60, height: 60 }}
                        value={458}
                        id="circle-progress-03"
                      >
                        <svg className="" width="24" viewBox="0 0 24 24">
                          <path
                            fill="currentColor"
                            d="M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z"
                          />
                        </svg>
                      </Circularprogressbar>
                      <div className="progress-detail">
                        <p className="mb-2">Total Vendors</p>
                        <h4 className="counter">
                          <CountUp
                            start={0}
                            end={dashboardData?.users?.vendor || 0}
                            duration={3}
                          />
                        </h4>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>

                {/* Pending KYC */}
                <SwiperSlide className="card card-slide">
                  <div className="card-body">
                    <div className="progress-widget">
                      <Circularprogressbar
                        stroke={variableColors.warning}
                        width="60px"
                        height="60px"
                        trailstroke="#ddd"
                        strokewidth="4px"
                        Linecap="rounded"
                        style={{ width: 60, height: 60 }}
                        value={23}
                        id="circle-progress-04"
                      >
                        <svg
                          className=""
                          width="24px"
                          height="24px"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z"
                          />
                        </svg>
                      </Circularprogressbar>
                      <div className="progress-detail">
                        <p className="mb-2">Pending KYC</p>
                        <h4 className="counter">
                          <CountUp
                            start={0}
                            end={
                              (dashboardData?.vendorKyc?.pending || 0) +
                              (dashboardData?.equipmentKyc?.pending || 0)
                            }
                            duration={3}
                          />
                        </h4>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>

                {/* Keep existing navigation buttons */}
                <div className="swiper-button swiper-button-next"></div>
                <div className="swiper-button swiper-button-prev"></div>
              </Swiper>
            </div>
          </Row>
        </Col>

        {/* Main Content Area */}
        <Col md="12" lg="8">
          <Row>
            {/* Jobs Analytics Chart */}
            <Col md="12">
              <div className="card" data-aos="fade-up" data-aos-delay="800">
                <div className="flex-wrap card-header d-flex justify-content-between">
                  <div className="header-title">
                    <h4 className="card-title">Jobs Analytics</h4>
                    <p className="mb-0">
                      {analyticsFilter === "weekly" ? "Weekly" : "Monthly"}{" "}
                      Overview
                    </p>
                  </div>
                  <Dropdown>
                    <Dropdown.Toggle
                      as={Button}
                      variant="text-gray"
                      type="button"
                      id="dropdownMenuButtonAnalytics"
                    >
                      {analyticsFilter === "weekly" ? "Weekly" : "Monthly"}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item
                        onClick={() => setAnalyticsFilter("weekly")}
                      >
                        Weekly Overview
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => setAnalyticsFilter("monthly")}
                      >
                        Monthly Overview
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                <div className="card-body">
                  <Chart
                    options={chart1?.options || {}}
                    series={chart1?.series || []}
                    type="area"
                    height="245"
                  />
                </div>
              </div>
            </Col>

            {/* Equipment Distribution */}
            <Col md="12" xl="12">
              <div className="card" data-aos="fade-up" data-aos-delay="900">
                <div className="flex-wrap card-header d-flex justify-content-between">
                  <div className="header-title">
                    <h4 className="card-title">Equipment Distribution</h4>
                  </div>
                  <Dropdown>
                    <Dropdown.Toggle
                      as={Button}
                      variant="text-gray"
                      type="button"
                      id="dropdownMenuButtonSM"
                    >
                      Weekly
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item href="#">Weekly OverView</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                <div className="card-body">
                  <div className="flex-wrap d-flex justify-content-between">
                    <Chart
                      className="col-md-8 col-lg-8"
                      options={chart2.options}
                      series={chart2.series}
                      type="donut"
                      height="250"
                    />

                    <div
                      className="d-grid gap col-md-4 col-lg-4"
                      style={{ overflowY: "auto", maxHeight: "250px" }}
                    >
                      {dashboardData.equipmentDistribution?.map((eq, index) => (
                        <div className="d-flex align-items-start" key={index}>
                          <svg
                            className="mt-2"
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            viewBox="0 0 24 24"
                            fill={chart2.options.colors[index] || "#000"}
                          >
                            <circle
                              cx="12"
                              cy="12"
                              r="8"
                              fill={chart2.options.colors[index] || "#000"}
                            ></circle>
                          </svg>
                          <div className="ms-3">
                            <span className="text-gray">{eq.name}</span>
                            <h6>{eq.percent}%</h6>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Col>

        {/* Right Sidebar */}
        <Col md="12" lg="4">
          <Row>
            <Col md="12" lg="12">
              <div className="card" data-aos="fade-up" data-aos-delay="700">
                <div className="card-header">
                  <h4 className="card-title">KYC Summary</h4>
                </div>
                <div className="card-body">
                  {/* Total KYC Applications */}
                  <div className="d-flex align-items-center mb-4">
                    <div className="p-3 rounded bg-soft-primary me-3">
                      <svg width="24" height="24" viewBox="0 0 24 24">
                        <path
                          fill="currentColor"
                          d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"
                        />
                      </svg>
                    </div>
                    <div>
                      <h5>Total KYC Applications</h5>
                      <div className="d-flex align-items-baseline">
                        <h2 className="mb-0 me-2">
                          {dashboardData?.vendorKyc?.total +
                            dashboardData?.equipmentKyc?.total || 0}
                        </h2>
                        <small className="text-success">+24 this week</small>
                      </div>
                    </div>
                  </div>

                  {/* KYC Status */}
                  <div className="kyc-stats mb-4">
                    <h6 className="mb-3">KYC Status</h6>
                    <div className="d-flex justify-content-between mb-2">
                      <p className="mb-0">Pending Verification</p>
                      <span className="text-warning">
                        {(dashboardData?.vendorKyc?.pending || 0) +
                          (dashboardData?.equipmentKyc?.pending || 0)}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between mb-2">
                      <p className="mb-0">Approved</p>
                      <span className="text-success">
                        {(dashboardData?.vendorKyc?.approved || 0) +
                          (dashboardData?.equipmentKyc?.approved || 0)}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between mb-2">
                      <p className="mb-0">Rejected</p>
                      <span className="text-danger">
                        {(dashboardData?.vendorKyc?.rejected || 0) +
                          (dashboardData?.equipmentKyc?.rejected || 0)}
                      </span>
                    </div>
                  </div>

                  {/* Verification Progress */}
                  <div className="kyc-progress mb-4">
                    <h6 className="mb-3">Verification Progress</h6>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <div>
                        <p className="mb-0">Equipment KYC</p>
                        <small className="text-muted">Total Registered</small>
                      </div>
                      <div className="d-flex align-items-center">
                        <h3 className="mb-0">
                          {dashboardData?.equipmentKyc?.total || 0}
                        </h3>
                        <small className="text-success ms-2">+12</small>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <p className="mb-0">Vendor KYC</p>
                        <small className="text-muted">Total Registered</small>
                      </div>
                      <div className="d-flex align-items-center">
                        <h3 className="mb-0">
                          {dashboardData?.vendorKyc?.total || 0}
                        </h3>
                        <small className="text-success ms-2">+8</small>
                      </div>
                    </div>
                  </div>

                  {/* Recent KYC Updates */}
                  <div className="recent-kyc">
                    <h6 className="mb-3">Recent KYC Updates</h6>

                    {/* Last Vendor KYC Update */}
                    <div className="d-flex align-items-start mb-3">
                      <div className="activity-icon bg-success-subtle text-success">
                        <svg width="20" height="20" viewBox="0 0 24 24">
                          <path
                            fill="currentColor"
                            d="M9,16.17L4.83,12l-1.42,1.41L9,19 21,7l-1.41-1.41L9,16.17z"
                          />
                        </svg>
                      </div>
                      <div className="ms-3">
                        <h6 className="mb-1">
                          Last Vendor KYC Update <br />
                          By - {userName}
                        </h6>
                        <p className="text-muted mb-0">
                          {dashboardData?.vendorKyc?.lastUpdatedAt
                            ? new Date(
                              dashboardData.vendorKyc.lastUpdatedAt
                            ).toLocaleString("en-US", {
                              year: "numeric",
                              month: "short",
                              day: "numeric",
                              hour: "numeric",
                              minute: "numeric",
                              hour12: true,
                            })
                            : "No updates yet"}{" "}
                        </p>
                      </div>
                    </div>

                    {/* Last Equipment KYC Update */}
                    <div className="d-flex align-items-start mb-3">
                      <div className="activity-icon bg-warning-subtle text-warning">
                        <svg width="20" height="20" viewBox="0 0 24 24">
                          <path
                            fill="currentColor"
                            d="M9,16.17L4.83,12l-1.42,1.41L9,19 21,7l-1.41-1.41L9,16.17z"
                          />
                        </svg>
                      </div>
                      <div className="ms-3">
                        <h6 className="mb-1">
                          Last Equipment KYC Update <br /> By- {userName}
                        </h6>
                        <p className="text-muted mb-0">
                          {dashboardData?.equipmentKyc?.lastUpdatedAt
                            ? new Date(
                              dashboardData.equipmentKyc.lastUpdatedAt
                            ).toLocaleString("en-US", {
                              year: "numeric",
                              month: "short",
                              day: "numeric",
                              hour: "numeric",
                              minute: "numeric",
                              hour12: true,
                            })
                            : "No updates yet"}{" "}
                        </p>
                      </div>
                    </div>

                    {/* Last Vendor Registration */}
                    <div className="d-flex align-items-start">
                      <div className="activity-icon bg-info-subtle text-info">
                        <svg width="20" height="20" viewBox="0 0 24 24">
                          <path
                            fill="currentColor"
                            d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"
                          />
                        </svg>
                      </div>
                      <div className="ms-3">
                        <h6 className="mb-1">New Vendor Registration</h6>
                        <p className="text-muted mb-0">
                          {dashboardData?.users?.lastVendorRegisteredAt
                            ? new Date(
                              dashboardData.users.lastVendorRegisteredAt
                            ).toLocaleString("en-US", {
                              year: "numeric",
                              month: "short",
                              day: "numeric",
                              hour: "numeric",
                              minute: "numeric",
                              hour12: true,
                            })
                            : "No vendors yet"}{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* Recent Jobs Table */}
          <Col md="12" lg="12">
            <div
              className="overflow-hidden card"
              data-aos="fade-up"
              data-aos-delay="600"
            >
              <div className="flex-wrap card-header d-flex justify-content-between">
                <div className="header-title">
                  <h4 className="mb-2 card-title">Recent Jobs</h4>
                  <p className="mb-0">
                    <svg
                      className="me-2"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="#3a57e8"
                        d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"
                      />
                    </svg>
                    {recentJobs.length} new Jobs this week
                  </p>
                </div>
              </div>
              <div className="p-0 card-body">
                <div className="mt-4 table-responsive">
                  <table
                    id="basic-table"
                    className="table mb-0 table-striped"
                    role="grid"
                  >
                    <thead>
                      <tr>
                        <th>Job ID#</th>
                        <th>Created Date</th>
                        <th>Customer</th>
                        <th>Vendor</th>
                        <th>Equipment</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>STATUS</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentJobs.length > 0 ? (
                        currentJobs.map((job) => {
                          // SAFE: Extract customer name
                          const customerName = getBilingualText(
                            job.customer,
                            "name"
                          );
                          const clientInitials =
                            customerName !== "N/A"
                              ? customerName
                                .split(" ")
                                .map((n) => n[0])
                                .join("")
                                .toUpperCase()
                              : "NA";

                          // SAFE: Extract vendor name
                          const vendorName = getBilingualText(
                            job.selectedVendor,
                            "name"
                          );
                          const contactInitials =
                            vendorName !== "N/A"
                              ? vendorName
                                .split(" ")
                                .map((n) => n[0])
                                .join("")
                                .toUpperCase()
                              : "CP";

                          const statusColor =
                            job.status === "live"
                              ? "success"
                              : job.status === "Pending"
                                ? "warning"
                                : job.status === "Complete"
                                  ? "success"
                                  : job.status == "extended"
                                    ? "info"
                                    : job.status == "Expired"
                                      ? "dark"
                                      : job.status == "Cancelled"
                                        ? "danger"
                                        : job?.status == "In-progress"
                                          ? "primary"
                                          : job?.status == "Paused"
                                            ? "secondary"
                                            : "light";

                          return (
                            <tr key={job._id}>
                              <td>#{job._id?.slice(-4)}</td>
                              <td>{formatDate(job.createdAt)}</td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <h6>{customerName}</h6>
                                </div>
                              </td>
                              <td>
                                <div className="iq-media-group iq-media-group-1">
                                  <Link
                                    to="/dashboard/app/vendor-listing"
                                    className="iq-media-1"
                                  >
                                    {vendorName}
                                  </Link>
                                </div>
                              </td>
                              <td>
                                {getBilingualText(job.equipmentType, "name")}
                              </td>
                              <td>{formatDate(job.jobDateTime)}</td>
                              <td>{formatDate(job.jobEndDateTime)}</td>
                              <td>
                                <span
                                  className={`badge bg-${statusColor} rounded-pill`}
                                >
                                  {job.status || "Unknown"}
                                </span>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="8" className="text-center">
                            No recent jobs found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Pagination controls */}
                {totalPages > 1 && (
                  <div className="d-flex justify-content-center mt-3">
                    <Pagination>
                      <Pagination.Prev
                        onClick={() =>
                          setCurrentPage((p) => Math.max(p - 1, 1))
                        }
                        disabled={currentPage === 1}
                      />
                      {Array.from({ length: totalPages }, (_, i) => (
                        <Pagination.Item
                          key={i + 1}
                          active={i + 1 === currentPage}
                          onClick={() => setCurrentPage(i + 1)}
                        >
                          {i + 1}
                        </Pagination.Item>
                      ))}
                      <Pagination.Next
                        onClick={() =>
                          setCurrentPage((p) => Math.min(p + 1, totalPages))
                        }
                        disabled={currentPage === totalPages}
                      />
                    </Pagination>
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Col>
      </Row>
    </Fragment>
  );
});

export default Index;
